
<template>
  <div class='MoralEducationRecord'>
    <van-search v-model="searchText" placeholder="请输入用户名/姓名" @search="FromSubmit" @clear="FromSubmit" />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" :offset=10 @load="loadList">
        <ul class="scrollList">
          <li v-for="item of pageList" :key="item.MoralEducationRecordID">
            <div class="box-body">
              <div class="list-body-box">
                <div class="fl">
                  <h3>
                    <span>{{item.FullName}} </span>
                  </h3>
                  <span>{{item.UserName}}</span>
                </div>
                <div class="fr">
                  <span>{{item.MoralEducationDimensionName}}{{item.MoralEducationDimensionTargetName}}{{!item.Score > 0 ? "减"+Math.abs(item.Score)+"分" : "加"+item.Score+"分"}}</span>
                </div>
                <div style="clear:both;"></div>
              </div>

              <h4 class="clearfix">
                <span class="fl">{{item.SchoolDistrictName}}</span>
                <span class="fl">{{item.StudentYearName}}</span>
                <span class="fr">{{item.StudentOrganizationName}}</span>
                <span class="fr">{{item.StudentGradeName}}</span>
              </h4>
            </div>
            <div class="box-footer">
              <div class="fl">
                <span>{{item.OperatorName}}</span>
              </div>
              <div class="fr">
                <span>{{item.LastModifyByDateName}}</span>
              </div>
              <div style="clear:both;"></div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data () {
    return {
      page: 1,
      pageSize: 15,
      pageList: [],
      searchText: "",
      isLoading: false,
      loading: false,
      finished:false,
    };
  },
  computed: {
    apipath () {
      return this.$store.state.apiPath
    }
  },
  created: function () {
    // this.pageList = [
    //   {
    //     MoralEducationRecordID: 2301,
    //     MoralEducationDimensionID: 0,
    //     MoralEducationDimensionTargetID: 1001,
    //     StudentID: 0,
    //     Score: 2.0,
    //     SchoolCardNumber: "10005",
    //     UserName: "xben05",
    //     FullName: "笨笨06",
    //     StudentOrganizationFullName: "1班",
    //     OperatorId: 13175,
    //     OperatorName: "真好24",
    //     MoralEducationDimensionName: "助人为乐",
    //     MoralEducationDimensionTargetName: "指标1",
    //     SchoolDistrictName: "東東校区",
    //     StudentYearName: "2018级",
    //     StudentGradeName: "初中",
    //     StudentOrganizationName: "1班",
    //     LastModifyByDate: "2019-10-23 13:04:28",
    //     LastModifyByDateName: "2019-10-23 13:04",
    //     DefaultScore: 2.0,
    //     MaxScore: 5.0,
    //     MinScore: 1.0
    //   },
    //   {
    //     MoralEducationRecordID: 1307,
    //     MoralEducationDimensionID: 0,
    //     MoralEducationDimensionTargetID: 1001,
    //     StudentID: 0,
    //     Score: 2.0,
    //     SchoolCardNumber: "cpxq021",
    //     UserName: "cpxq021",
    //     FullName: "kimi021",
    //     StudentOrganizationFullName: "3班",
    //     OperatorId: 3,
    //     OperatorName: "xymanager",
    //     MoralEducationDimensionName: "助人为乐",
    //     MoralEducationDimensionTargetName: "指标1",
    //     SchoolDistrictName: "昌平校区",
    //     StudentYearName: "2018级",
    //     StudentGradeName: "高中",
    //     StudentOrganizationName: "3班",
    //     LastModifyByDate: "2019-07-09 10:31:29",
    //     LastModifyByDateName: "2019-07-09 10:31",
    //     DefaultScore: 2.0,
    //     MaxScore: 5.0,
    //     MinScore: 1.0
    //   }
    // ]
    this.loadList()
  },
  methods: {
    loadList () {
      this.xy.loading()
      let that = this
      let obj = {
        pageIndex: that.page,
        pageSize: that.pageSize,
        searchText: that.searchText
      };
      let ulr = `${this.apipath}/api/MoralEducationRecord/GetPageList`
      this.xyapi.get(ulr, obj).then(res => {
        let list = res.data.data
        that.pageList = [...that.pageList, ...list]
        that.loading = false
        this.xy.unloading()
        that.page++
        that.finished = (that.pageList.length >= res.data.totalRecords) ? true : false
      });
    },
    FromSubmit: function () {
      this.page = 1;
      this.pageList = []
      this.loadList()
    },
    onRefresh () {
      setTimeout(() => {
        this.pageList = []
        this.page = 1
        this.isLoading = false
        this.loadList()
      }, 500)
    }
  }
};
</script>
 <style lang='less' scoped>
.scrollList {
  li {
    background: #fff;
      padding: 15px;
    margin: 20px 0;
    .box-body {
      border-bottom: 1px solid #eee;
      padding: 20px 10px;
      h3 {
        margin-bottom: 20px;
        font-size: 32px;
        color: #333;
        span{
          font-size: 26px;
        }
      }
      .list-body-box {
        margin-bottom: 20px;
      }
    }
    .box-footer {
      padding: 20px;
    }
  }
}
</style>